<template>
  <div class="land-map">
    <div v-if="!myLatLng" class="draw-map-btn" @click="popup.mapDraw.visible = true">
      {{ emptyText }}
    </div>
    <template v-else>
      <wh-map-draw
        :style="{
          height,
          width
        }"
        class="map-draw"
        :editable="false"
        :geometry-j-s-o-n="myLatLng"
      />
      <div class="options">
        <van-button v-if="editAble" native-type="button" type="primary" size="mini" @click="drawPlotOutline">
          编辑
        </van-button>
        <van-button v-if="deleteAble" native-type="button" size="mini" @click="deleteMap">
          删除
        </van-button>
      </div>
    </template>
    <map-draw-popup
      :height="100"
      :visible.sync="popup.mapDraw.visible"
      :edit-geometry-data="myLatLng"
      @change="mapDrawDataChange"
    />
  </div>
</template>

<script>
import WhMapDraw from '@/components/public/WhMapDraw/WhMapDraw'
import MapDrawPopup from '@/views/productManage/components/PlotPopup/MapDrawPopup'
export default {
  name: 'LandMap',
  components: { MapDrawPopup, WhMapDraw },
  model: {
    prop: 'latLng',
    event: 'input'
  },
  props: {
    emptyText: {
      type: String,
      default: '绘制地块真实位置'
    },
    latLng: {
      type: String,
      default: ''
    },
    editAble: {
      type: Boolean,
      default: true
    },
    deleteAble: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '160px'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      myLatLng: '',
      popup: {
        mapDraw: {
          visible: false
        }
      }
    }
  },
  watch: {
    latLng: {
      handler(newVal) {
        this.myLatLng = newVal
      },
      immediate: true
    }
  },
  methods: {
    deleteMap() {
      this.$dialog.confirm({
        title: '是否删除地图？'
      })
        .then(() => {
          // on confirm
          this.$emit('deleteMap', true)
        })
        .catch(() => {
          // on cancel
          this.$emit('deleteMap', false)
        })
    },
    drawPlotOutline() {
      this.popup.mapDraw.visible = true
    },
    mapDrawDataChange(mapDrawData) {
      this.$emit('input', JSON.stringify(mapDrawData.geometryJSON))
      this.$emit('change', mapDrawData)
    }
  }
}
</script>

<style lang='less' scoped>
.draw-map-btn {
  color: @primary-color;
}
.land-map {
  position: relative;
  width: 100%;
  .options {
    opacity: 0.7;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 21;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
